/**
 * @license Siftrock
 * (c) 2014-2019 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import * as InboxSocket from './sockets/inbox.socket';

@Injectable()
export class SocketService {
    constructor(private socket: Socket) { }

    private accountId = null;

    public joinChannel(accountId: string) {
        this.accountId = accountId;
        this.socket.emit('Join', accountId);
    }

    public disconnect() {
        // force to disconnect
        this.socket.disconnect();
    }

    public connect() {
        // force to connect
        this.socket.connect();
    }

    // ********************  Inbox events ****************************
    /**
     * anything related to the inbox.
     * It send the email that was updated
     *
     * @param emailId collection of emailId and any additional data we need to handle the event
     * @param accountId
     */
    public sendEmailDetailUpdate(data) {
        InboxSocket.sendEmailDetailUpdate(this.socket, this.accountId, data);
    }

    /**
     * listener for the specific event that will be consumed by
     * the component. We only will be listening to certain events
     * on each page.
     */
    public getEmailDetailUpdate = () => {
        return InboxSocket.getEmailDetailUpdate(this.socket);
    }
}



// WEBPACK FOOTER //
// ./client/app/services/socket.service.ts